/**
 * @generated SignedSource<<1ab88c86ecf711245680266df88d829b>>
 * @relayHash 30943931b9ef970914fcabde1ec18427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type useCommentByIdQuery$variables = {
  commentId?: string | null;
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null> | null;
  inlineMarkerRef?: string | null;
  pageId: string;
};
export type useCommentByIdQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly __typename: string;
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly permissionType: SitePermissionType | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      };
      readonly body: {
        readonly value: string;
      };
      readonly container: {
        readonly id: string | null;
      };
      readonly contentStatus: string;
      readonly contributors: ReadonlyArray<{
        readonly __typename: string;
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null> | null;
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      };
      readonly location: {
        readonly __typename: string;
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineMarkerRef?: string | null;
        readonly inlineResolveProperties?: {
          readonly isDangling: boolean;
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineText?: string | null;
        readonly type: string;
      };
      readonly parentId: string | null;
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly reactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly __typename: string;
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly contributors: ReadonlyArray<{
          readonly __typename: string;
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null> | null;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        };
        readonly location: {
          readonly __typename: string;
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineMarkerRef?: string | null;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineText?: string | null;
          readonly type: string;
        };
        readonly parentId: string | null;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly reactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly version: {
          readonly by: {
            readonly __typename: string;
            readonly displayName: string | null;
          } | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null>;
      readonly version: {
        readonly by: {
          readonly __typename: string;
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly type: string | null;
        } | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      };
    } | null> | null;
  } | null;
};
export type useCommentByIdQuery = {
  response: useCommentByIdQuery$data;
  variables: useCommentByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inlineMarkerRef"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v4 = {
  "kind": "Variable",
  "name": "pageId",
  "variableName": "pageId"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v9 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v12 = {
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/)
  ]
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v15 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v16 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v13/*: any*/)
},
v17 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v18 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editui"
    },
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v20 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v21 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v22 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v23 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v10/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "commentResolveProperties",
          "plural": false,
          "selections": [
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/)
          ]
        }
      ],
      "type": "FooterComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "inlineMarkerRef"
        },
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "inlineResolveProperties",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isDangling"
            },
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "inlineText"
        }
      ],
      "type": "InlineComment"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v25 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v26 = {
  "args": [
    {
      "kind": "Literal",
      "name": "childType",
      "value": "comment"
    },
    {
      "kind": "Literal",
      "name": "contentType",
      "value": "page"
    },
    (v4/*: any*/)
  ],
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "reactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "number"
},
v28 = {
  "kind": "ScalarField",
  "name": "when"
},
v29 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "commentId"
      },
      {
        "kind": "Variable",
        "name": "contentStatus",
        "variableName": "contentStatus"
      },
      {
        "kind": "Variable",
        "name": "inlineMarkerRef",
        "variableName": "inlineMarkerRef"
      },
      (v4/*: any*/)
    ],
    "concreteType": "PaginatedCommentList",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": [
      {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ]
          },
          (v12/*: any*/),
          (v14/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ]
          },
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "replies",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/)
                ]
              },
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v27/*: any*/),
                  (v28/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v10/*: any*/),
                  (v7/*: any*/),
                  (v11/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "friendlyWhen"
              },
              (v27/*: any*/),
              (v28/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCommentByIdQuery",
    "selections": (v29/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCommentByIdQuery",
    "selections": (v29/*: any*/)
  },
  "params": {
    "cacheID": "30943931b9ef970914fcabde1ec18427",
    "id": "e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454",
    "metadata": {},
    "name": "useCommentByIdQuery",
    "operationKind": "query",
    "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
  }
};
})();

(node as any).hash = "e144cc71550d14f94a82d8439ed2ba0e";

export default node;
